// First path segments the regional rewrites strip. path-to-regexp sources cannot use alternation, so
// each shape is its own entry. The SSR prefetch gate consumes INTL_SEGMENT and takes the country and
// marketing regions from the region tables instead, which is what the middleware validates against.
export const TWO_LETTER_REGION_SEGMENT = '(?!tn)(?!tv)[a-zA-Z]{2}';
export const NAMED_REGION_SEGMENTS = ['gsa', 'latam'];
export const INTL_SEGMENT = 'intl';
